
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { debounce } from "throttle-debounce-ts";

const ICONS = {
  search: "search",
};

const DEBOUNCE_TIMEOUT = 500;

type ParamsKeyObject = {
  [key: string]: any;
};

@Component
export default class TableSearchbar extends Vue {
  @Prop({ type: Object }) readonly params?: ParamsKeyObject;
  @Prop({ type: Number, default: 0 }) readonly total?: number;
  @Prop({ type: Boolean, default: false }) readonly showTotal?: boolean;
  @Prop({ type: String, default: "" }) readonly placeholder?: string;

  query = "";

  get searchBarProps() {
    return {
      iconPrepend: ICONS.search,
      placeholder: this.placeholder || this.$tc("searchbar.placeholder"),
    };
  }

  get counterLabel() {
    const count = this.total;

    if (count === 1) return this.$tc("header.counter", 1, { count });

    return this.$tc("header.counter", 2, { count });
  }

  debounceUpdate = debounce(DEBOUNCE_TIMEOUT, this.updateQuery);

  async updateQuery() {
    this.$emit("update-query", { params: this.params, isLimit: false });
  }

  @Watch("query")
  queryChanged(query: string) {
    const payload = {
      ...this.params,
      search: query,
    };

    this.$emit("update:params", payload);

    this.$nextTick(() => {
      this.debounceUpdate();
    });
  }
}
